import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStackVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		clipPath: "url(#stack-vertical-clip)",
		children: [/* @__PURE__ */ _jsx("path", { d: "M8 0 1 5l7 5 7-5z" }), /* @__PURE__ */ _jsx("path", { d: "m1 11 2.48-1.771L8 12.458l4.52-3.23L15 11l-7 5z" })]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "stack-vertical-clip",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgStackVertical;
